export default __webpack_public_path__ + "fb494f33e0e7499cc2c1c600ce561639.png";